import { useTranslation } from "react-i18next";
import { SECONDARY_COLOR } from "../constants/colors";
import { PaymentMethodEnum } from "../enums/paymentMethod";

interface Props {
    paymentMethod: PaymentMethodEnum
}



const PaymentMethodText = ({ paymentMethod }: Props) => {
    const { t } = useTranslation("global");
    const convertPaymentMethodToBackgroundColor = (): string => {
        switch (paymentMethod) {
            case PaymentMethodEnum.BCELONE:
                return "red";
            case PaymentMethodEnum.CASH:
                return SECONDARY_COLOR;
            default:
                return paymentMethod;
        }
    }
    return <span style={{ fontWeight: 'bold', backgroundColor: convertPaymentMethodToBackgroundColor(), 
    
    borderRadius: "6px",
        padding: "2px 8px",
        lineHeight: 3,
    
    color: 'white', minWidth: "87px" }}>
        {
            paymentMethod === PaymentMethodEnum.CASH
                ?
                t("CASH")
                :
                paymentMethod === PaymentMethodEnum.BCELONE
                    ?
                    t("BCELONE")
                    :
                    paymentMethod
        }
    </span>
}
export default PaymentMethodText;